import { Star } from 'lucide-react';

export function pluralReviews(n: number) {
  if (n % 10 === 1 && n % 100 !== 11) return 'отзыв';
  if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)) return 'отзыва';
  return 'отзывов';
}

export function groupSlotsByDate(slots: { date?: string | Date; startAt?: string; [key: string]: unknown }[]) {
  const map: Record<string, typeof slots> = {};
  for (const slot of slots) {
    let key: string;
    if (slot.startAt) {
      key = new Date(slot.startAt).toLocaleDateString('en-CA'); // YYYY-MM-DD локальное
    } else {
      key = typeof slot.date === 'string' ? slot.date.slice(0, 10) : new Date(slot.date as Date).toISOString().split('T')[0];
    }
    if (!map[key]) map[key] = [];
    map[key].push(slot);
  }
  return Object.entries(map).sort(([a], [b]) => a.localeCompare(b));
}

export function formatSlotDate(dateStr: string) {
  const [year, month, day] = dateStr.slice(0, 10).split('-').map(Number);
  const d = new Date(year, month - 1, day);
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const tomorrow = new Date(today); tomorrow.setDate(today.getDate() + 1);
  if (d.getTime() === today.getTime()) return 'Сегодня';
  if (d.getTime() === tomorrow.getTime()) return 'Завтра';
  return d.toLocaleDateString('ru-RU', { weekday: 'short', day: 'numeric', month: 'short' });
}

export function getSlotTime(slot: { startTime?: string; start_time?: string; startAt?: string }) {
  if (slot.startAt) return new Date(slot.startAt).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
  const t = slot.startTime ?? slot.start_time ?? '';
  return t.length > 5 ? t.slice(11, 16) : t;
}

export default function StarRating({ value }: { value: number }) {
  return (
    <div className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map(i => (
        <Star key={i} size={14}
          className={i <= value ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300 fill-gray-300'} />
      ))}
    </div>
  );
}
